import React, { Component } from 'react';
import { connect } from 'react-redux';

class Help extends Component {
  render() {
    let display = this.props.helpMode ? "inline-block" : 'none';
    let color = this.props.color ? this.props.color : 'white';
    return (
			<i className="material-icons" data-tip={this.props['dataTip']} style={{color,fontSize:"14px",paddingLeft:'2px',display,lineHeight:'1',height:'1'}} >help_outline</i>
		)
  }
}


function mapStateToProps(state,props) {
  return {
    helpMode: state.ui_passport.helpMode,
  };
}


export default connect(mapStateToProps, {})(Help);
